import type { PageCrumb } from '../../../components/agwa-page-header';
import type { LoginGroup } from '../../../api/agwa-api-model';
import { resolveRouterPath } from '../../../router';
import { terms } from '../../../language/terms';
import { WellKnownIds } from '../../../utility/claim-id';
import {
  companiesCrumb,
  companyCrumb,
  companyStaffCrumb,
} from '../../app-members/shared/company-trail';

/**
 * The trail above a staff member's add and edit pages (the trail standard, architect
 * 2026-09-06). Where the list of staff lives depends on whose staff they are, and the trail
 * says so rather than pretending one "Staff" link fits both:
 *
 *  - AGWA's own staff are listed on the AGWA Staff page: `Staff > {user}`.
 *  - A company's staff are a tab of that company's workspace:
 *    `Companies > {company} > Staff > {user}`.
 *
 * Until the group has loaded there is no trail. The pages hold their record and their group
 * back until both arrive, so this is the moment before either renders, not a flicker.
 *
 * This is the trail, not the return: `returnUrl` still decides where a save lands, because a
 * person who opened the editor from a filtered list should go back to that list.
 */
export function staffTrail(
  group: Pick<LoginGroup, 'id' | 'name'> | null
): PageCrumb[] {
  if (!group) return [];
  if (group.id.toLowerCase() === WellKnownIds.agwaGroupId) {
    // AGWA's own people, so the AGWA staff term, not the company sense held in C16c.
    return [
      { label: terms.staffUser.value, href: resolveRouterPath('module/staff') },
    ];
  }
  return [companiesCrumb(), companyCrumb(group), companyStaffCrumb(group.id)];
}
